export default __webpack_public_path__ + "0cad61cb484c4736669b54695c518a5e.webp";